/* Barlen Laagste Prijsgarantie: de link onder de koopknop en de kaart gaan naar de pagina van de garantie, met het kleed en
   de keuze in het adres; op de pagina staat dat kleed dan al in het bericht van de knoppen WhatsApp en mail. Die knoppen maakt
   barlen-onthul.js pas bij de klik; dit script vult alleen het adres en het bericht. */
(function () {
  'use strict';
  if (window.bcPrijsbelofte) return;
  window.bcPrijsbelofte = true;

  var KEUZE = ['spoor', 'vorm', 'maat', 'kleur', 'b', 'l', 'd'];
  var kort = function (v, n) { return (v || '').replace(/\s+/g, ' ').trim().slice(0, n || 60); };

  /* De link krijgt vlak voor de klik de keuze uit het adres van de productpagina, en de prijs en de overige opties (zoals de
     uitvoering) zoals ze in de kleedviewer staan. */
  function aanvraagBijwerken(link) {
    try {
      var nu = new URLSearchParams(window.location.search);
      var url = new URL(link.getAttribute('href'), window.location.href);
      KEUZE.forEach(function (k) {
        var v = nu.get(k);
        if (v) url.searchParams.set(k, v); else url.searchParams.delete(k);
      });
      var kv = link.closest('.kv') || document.querySelector('.kv');
      var prijsEl = kv ? kv.querySelector('[data-kv-prijs]') : null;
      var prijs = prijsEl ? kort(prijsEl.textContent) : '';
      if (/\d/.test(prijs)) url.searchParams.set('prijs', prijs); else url.searchParams.delete('prijs');
      var spoor = kv ? (kv.getAttribute('data-spoor-nu') || kv.getAttribute('data-spoor') || 'std') : 'std';
      if (spoor === 'mw') url.searchParams.set('spoor', 'maat');
      var extra = kv ? Array.prototype.map.call(kv.querySelectorAll('input[data-kv-optie="' + spoor + '"][data-kv-soort="tekst"]:checked'), function (i) {
        var veld = i.closest('[data-kv-veld]');
        return kort((veld && veld.getAttribute('data-kv-naam')) || 'Keuze', 30) + ': ' + kort(i.value, 40);
      }) : [];
      if (extra.length) url.searchParams.set('extra', extra.join('|')); else url.searchParams.delete('extra');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (e) { /* de link werkt ook zonder keuze */ }
  }

  /* De link onder de koopknop (data-pb-aanvraag) en de knop van de kaart (data-pbb-knop). */
  function links() {
    Array.prototype.forEach.call(document.querySelectorAll('a[data-pb-aanvraag], a[data-pbb-knop]'), function (a) {
      if (a.getAttribute('data-pb-klaar')) return;
      a.setAttribute('data-pb-klaar', '1');
      a.addEventListener('click', function () { aanvraagBijwerken(a); });
    });
  }

  /* Op de pagina: komt de bezoeker van een kleed (?kleed=<handle>, met de keuze), dan staat dat kleed al in het bericht:
     kleed, vorm, maat, kleur, de overige opties en de prijs, met een plek voor de link of prijs van de andere winkel. */
  function pagina() {
    var vak = document.querySelector('[data-pb-pagina]');
    if (!vak) return;
    var knoppen = vak.querySelectorAll('[data-pb-kanaal]');
    var q = new URLSearchParams(window.location.search);
    var handle = (q.get('kleed') || '').toLowerCase();
    if (!knoppen.length || !/^[a-z0-9][a-z0-9-]{0,200}$/.test(handle)) return;

    var getal = function (v) { return /^[0-9]{2,4}$/.test(v || '') ? v : ''; };
    var b = getal(q.get('b'));
    var l = getal(q.get('l'));
    var d = getal(q.get('d'));
    var vorm = kort(q.get('vorm'));
    var maat = kort(q.get('maat'));
    var kleur = kort(q.get('kleur'));
    var prijs = kort(q.get('prijs'));
    var opMaat = q.get('spoor') === 'maat' || b || d;
    var regels = [];
    if (vorm) regels.push('Vorm: ' + vorm);
    if (opMaat) {
      if (d) regels.push('Maat: Ø ' + d + ' cm, op maat');
      else if (b && l) regels.push('Maat: ' + b + ' × ' + l + ' cm, op maat');
      else regels.push('Maat: op maat, nog in te vullen');
    } else if (maat) regels.push('Maat: ' + maat);
    if (kleur) regels.push('Kleur: ' + kleur);
    (q.get('extra') || '').split('|').slice(0, 4).forEach(function (x) { if (/^[^:|]{1,30}: [^|]{1,40}$/.test(x)) regels.push(x); });
    if (/^€\s?[\d.]+(,\d{2})?( per m²)?$/.test(prijs)) regels.push('Prijs bij Barlen: ' + prijs);

    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(basis + 'products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.title) return;
        var tekst = ['Barlen Laagste Prijsgarantie', 'Kleed: ' + kort(String(p.title), 90)].concat(regels)
          .concat([window.location.origin + basis + 'products/' + handle, 'Hier zag ik het voor minder (link of prijs): ']).join('\n');
        Array.prototype.forEach.call(knoppen, function (a) { a.setAttribute('data-bf-bericht', tekst); });
      })
      .catch(function () { /* dan blijft het bericht zonder kleed */ });
  }

  function start() { links(); pagina(); }
  /* In de thema-editor wordt een sectie opnieuw geladen na elke wijziging; dan de links opnieuw koppelen. */
  document.addEventListener('shopify:section:load', links);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
